// @flow
import AddActivityController from './AddActivityController'

export default AddActivityController
